/* cl-interactive (atolea): vida das secoes copiadas do Prestige dele.
   1. Swiper 11 (lib oficial, assets/cl-swiper.js) com a MESMA config do custom.js dele:
      .mySwiper-review (home/PDP) e .mySwiper-productCard (colecao, so mobile).
      O extract grava o estado ja inicializado (classes swiper-*, width/margin inline nos slides,
      transform no wrapper, bullets prontos) -> desfaz antes de iniciar.
   2. Acordeoes (FAQ / abas da PDP): <details> nativo e o padrao Collapsible do Prestige
      (button[aria-expanded] + [aria-controls]).
   3. Nota do operador: nada de timer na loja -> qualquer contador regressivo copiado fica oculto
      pelo CSS (cl-global). */
(function () {
  if (window.__clInteractive) return; window.__clInteractive = true;

  function unbake(root) {
    root.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden', 'swiper-pointer-events');
    root.querySelectorAll('.swiper-wrapper').forEach(function (w) { w.style.transform = ''; w.style.transitionDuration = ''; w.removeAttribute('id'); });
    root.querySelectorAll('.swiper-slide').forEach(function (s) {
      s.style.width = ''; s.style.marginRight = ''; s.style.marginLeft = '';
      s.classList.remove('swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev');
    });
  }
  function scopeOf(root) { return root.closest('[class*="cl-sec-"]') || root.parentElement; }
  function clearBullets(el) { if (el) el.innerHTML = ''; return el; }

  var CONFIGS = [
    { sel: '.mySwiper-review', when: function () { return true; }, opts: function (sc) { return {
        slidesPerView: 1.3, spaceBetween: 20, centeredSlides: true, loop: false,
        pagination: { el: clearBullets(sc.querySelector('.swiper-pagination-review')), clickable: true },
        navigation: { nextEl: sc.querySelector('.swiper-button-next-review'), prevEl: sc.querySelector('.swiper-button-prev-review') },
        breakpoints: { 768: { slidesPerView: 3, spaceBetween: 20, centeredSlides: false },
                       1024: { slidesPerView: 4, spaceBetween: 20, centeredSlides: false } } }; } },
    { sel: '.product_image_swiper_slider', when: function () { return true; }, opts: function (sc) { return {
        slidesPerView: 1.4, spaceBetween: 24, centeredSlides: false, loop: false,
        navigation: { nextEl: sc.querySelector('.image_swiper_arrows .swiper-button-next'), prevEl: sc.querySelector('.image_swiper_arrows .swiper-button-prev') },
        breakpoints: { 800: { slidesPerView: 5, spaceBetween: 24, centeredSlides: false }, 480: { slidesPerView: 2.8, spaceBetween: 24 } } }; } },
    { sel: '.mySwiper-productCard', when: function () { return document.body.clientWidth <= 768; }, opts: function (sc) { return {
        spaceBetween: 30, speed: 1000,
        pagination: { el: clearBullets(sc.querySelector('.swiper-pagination-productCard')), clickable: true },
        breakpoints: { 768: { slidesPerView: 3, spaceBetween: 20, speed: 1000, centeredSlides: false },
                       1024: { slidesPerView: 4, spaceBetween: 20, speed: 1000, centeredSlides: false } } }; } }
  ];

  function initSwipers() {
    if (!window.Swiper) return false;
    CONFIGS.forEach(function (c) {
      document.querySelectorAll(c.sel).forEach(function (el) {
        if (el.__clSwiper || !c.when()) return;
        unbake(el);
        try { el.__clSwiper = new window.Swiper(el, c.opts(scopeOf(el))); } catch (e) { console.warn('cl swiper', e); }
      });
    });
    return true;
  }

  /* acordeao Replo (Radix Collapsible) sem o runtime do Replo: o item tem
     [data-replo-collapsible] > [role=button] + <div hidden> com a resposta (colhida por grab_replo_faq.py) */
  function reploCollapsibles() {
    function toggle(btn) {
      var item = btn.parentElement, content = btn.nextElementSibling;
      if (!item || !content) return;
      var open = item.getAttribute('data-state') !== 'open';
      item.setAttribute('data-state', open ? 'open' : 'closed');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('data-state', open ? 'open' : 'closed');
      content.setAttribute('data-state', open ? 'open' : 'closed');
      if (open) content.removeAttribute('hidden'); else content.setAttribute('hidden', '');
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[class*="cl-sec-"] [data-replo-collapsible] > [role="button"]');
      if (btn) { e.preventDefault(); toggle(btn); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var btn = e.target.closest && e.target.closest('[class*="cl-sec-"] [data-replo-collapsible] > [role="button"]');
      if (btn) { e.preventDefault(); toggle(btn); }
    });
  }

  function accordions() {
    reploCollapsibles();
    /* <details> nativo: o icone +/- do tema dele le aria-expanded (o accordion-disclosure dele sincronizava) */
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (d && d.tagName === 'DETAILS' && d.closest('[class*="cl-sec-"]')) d.setAttribute('aria-expanded', d.open ? 'true' : 'false');
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-replo-collapsible]')) return;
      var b = e.target.closest('[class*="cl-sec-"] button[aria-controls], [class*="cl-sec-"] .Collapsible__Button');
      if (!b) return;
      var id = b.getAttribute('aria-controls');
      var panel = id ? document.getElementById(id) : null;
      if (!panel) { var host = b.closest('.Collapsible, [class*="collapsible"], [class*="accordion"], [class*="faq"]'); panel = host && host.querySelector('.Collapsible__Inner, [class*="content"], [class*="answer"], [class*="panel"]'); }
      if (!panel) return;
      e.preventDefault();
      var open = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.style.overflow = 'hidden';
      panel.style.transition = 'height .3s ease';
      if (open) {
        panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(function () { panel.style.height = '0px'; });
        panel.setAttribute('aria-hidden', 'true');
      } else {
        panel.style.visibility = 'visible';
        panel.style.height = panel.scrollHeight + 'px';
        panel.setAttribute('aria-hidden', 'false');
        setTimeout(function () { if (b.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto'; }, 320);
      }
    });
  }

  /* colecao: Sort (popover com collection.sort_options), filtros nativos (form GET envia na
     mudanca) e o botao Filter do mobile abre a barra de filtros como gaveta */
  function collectionUi() {
    document.addEventListener('click', function (e) {
      var s = e.target.closest('[data-cl-sort]');
      var pops = document.querySelectorAll('[data-cl-sort-pop]');
      if (s) { e.preventDefault(); var p = s.parentNode.querySelector('[data-cl-sort-pop]'); if (p) p.hidden = !p.hidden; return; }
      if (!e.target.closest('[data-cl-sort-pop]')) pops.forEach(function (p) { p.hidden = true; });
      var f = e.target.closest('[data-cl-filter]');
      if (f) { e.preventDefault(); document.documentElement.classList.toggle('cl-facets-open'); return; }
      if (document.documentElement.classList.contains('cl-facets-open') && e.target.closest('.cl-facets-close')) document.documentElement.classList.remove('cl-facets-open');
    });
    document.addEventListener('change', function (e) {
      var form = e.target.closest('form[data-cl-facets]');
      if (form) form.submit();
    });
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-cl-facets]');
      if (!form) return;
      form.querySelectorAll('input[name="sort_by"]').forEach(function (i) { if (!i.value) i.disabled = true; });
    }, true);
  }

  /* videos de fundo/hero (Tolstoy, Replo): no site dele o JS do app da play; aqui todo <video> mudo e sem
     controles das secoes copiadas toca em loop enquanto esta na tela (nota do operador: video tem que tocar) */
  function autoVideos() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('[class*="cl-sec-"] video[muted], [class*="cl-sec-"] video'))
      .filter(function (v) { return !v.controls && (v.muted || v.hasAttribute('muted')); });
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); });
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) e.target.play().catch(function () {}); else e.target.pause(); });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function boot() {
    autoVideos();
    if (!initSwipers()) {
      var n = 0, t = setInterval(function () { if (initSwipers() || ++n > 40) clearInterval(t); }, 150);
    }
    window.addEventListener('resize', function () { initSwipers(); });
  }
  accordions();
  collectionUi();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
